import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  Discrepancy,
  ILeadSearchParams,
  ILeadsToBulkSearchParams,
  ILoadDiscrepanciesResponse,
} from '../model/Discrepancy';
import {
  ContactInteraction,
  DiscrepancyLead,
  DiscrepancyLeadToBulk,
  IEmailStatus,
  IInteraction,
  ILead,
  ILeadInteractionsData,
  ISelectsData,
} from '../model/DiscrepancyLeadToBulk';
import { AppConstants } from '../resources/app-constants';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class DiscrepanciesDataService {
  private selectedSearchIteam = new BehaviorSubject<ILeadInteractionsData>(null);
  private refreshInteractions = new BehaviorSubject<boolean>(false);
  public EDITABLE_CUSTOMERS_IDS = [4, 31, 42];
  public CONDITIONAL_QUALIFICATION_IDS = [4, 5, 6];
  public newSearch = new BehaviorSubject<ILeadSearchParams>(null);
  constructor(private httpClient: HttpClient) {}
  private selectedInteractionItem = new BehaviorSubject<IInteraction>(null);

  setSearchParams(params: ILeadSearchParams) {
    this.newSearch.next(params);
  }

  get newSearchParams() {
    return this.newSearch.asObservable();
  }

  get selectedSearchResult() {
    return this.selectedSearchIteam.asObservable();
  }

  selectSearchItem(lead: ILeadInteractionsData) {
    this.selectedSearchIteam.next(lead);
  }

  get selectedInteraction() {
    return this.selectedInteractionItem.asObservable();
  }

  selectInteractionItem(interaction: IInteraction) {
    this.selectedInteractionItem.next(interaction);
  }

  get interactionsUpdated() {
    return this.refreshInteractions.asObservable();
  }

  setInteractionsUpdated(created: boolean) {
    this.refreshInteractions.next(created);
  }

  private formatSearchStartDate(date: string | Date) {
    return `${dayjs(date).format('YYYY-MM-DD')}T00:00:00.000Z`;
  }

  private formatSearchEndDate(date: string | Date) {
    return `${dayjs(date).format('YYYY-MM-DD')}T23:59:00.000Z`;
  }
}
